/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import router from '@/router';
import mqtt from '@/plugins/mqtt';

import useAuthStore from '@/store/modules/pinia/auth';
import useLdapStore from '@/store/modules/pinia/ldap';
import { AuthApiService } from '@/services/api';
import logger from '@/plugins/logger';

/**
 * @description Handle user logout
 */
const handleLogout = async () => {
  const authStore = useAuthStore();
  const ldapStore = useLdapStore();
  try {
    await AuthApiService.logout();
    await mqtt.disconnect();
    await ldapStore.getLdapStatus();
  } catch (e) {
    logger.error('Error during logout:', e);
  } finally {
    authStore.clearAuthState();
    router.push({ name: 'Login' });
  }
};

export default handleLogout;
